import { render, staticRenderFns } from "./PaymentErrorModal.vue?vue&type=template&id=198307f5&scoped=true"
import script from "./PaymentErrorModal.vue?vue&type=script&lang=js"
export * from "./PaymentErrorModal.vue?vue&type=script&lang=js"
import style0 from "./PaymentErrorModal.vue?vue&type=style&index=0&id=198307f5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "198307f5",
  null
  
)

export default component.exports